module.exports = __webpack_public_path__ + "static/media/feather-webfont.4a878d5b.svg";